export interface EvidenceRecordingSettings {
	recordVideo: "preferTab" | "preferBrowser" | "preferScreen" | "none"
	proxyDomMessageEventsToDetectDataRead: boolean;
	proxyDomEventsToDetectPropertiesRead: boolean;
	recordGeolocationEvents: boolean;
	setGeolocationTo: { latitude: number, longitude: number, accuracy?: number } | undefined;
	monitorInboundNetworkTraffic: boolean;
	archiveDirectoryHandle: FileSystemDirectoryHandle | undefined;
	crawlTargetsFileHandle?: FileSystemFileHandle;
	crawlOutputDirectoryHandle?: FileSystemDirectoryHandle;
}

export interface DataGoesWhereSettings extends EvidenceRecordingSettings {
	sharedSearchTerms?: string;
}

export const defaultDataGoesWhereSettings: DataGoesWhereSettings = {
	recordVideo: "preferBrowser",
	proxyDomMessageEventsToDetectDataRead: true,
	proxyDomEventsToDetectPropertiesRead: true,
	recordGeolocationEvents: true,
	setGeolocationTo: { latitude: 86.753099035768, longitude: -86.753099035768 },
	monitorInboundNetworkTraffic: true,
	archiveDirectoryHandle: undefined,
}

export type DataGoesWhereSettingsPartial = Partial<DataGoesWhereSettings>;

export type DataGoesWhereSettingsUpdate = {
	[k in keyof DataGoesWhereSettingsPartial]: DataGoesWhereSettingsPartial[k] | undefined;
};